function isInSubtree(tree, nodeId, subtreeId) {
	if (!tree.get(nodeId)) {
		return false
	}
	if (nodeId == subtreeId) {
		return true
	}

	for (var parent; parent = tree.parent(nodeId); ) {
		nodeId = parent.id
		if (nodeId == subtreeId) {
			return true
		}
	}
	return false
}

export default isInSubtree


isInSubtree.__filename__ = 'components/is-in-subtree.js'
